import './SelectLineItemsStep.scss';

import { bem } from 'mission-control-common-components';
import React, { useMemo } from 'react';

import { useDuplicateAdsStepperContext } from '../../DuplicateAdsStepperProvider/DuplicateAdsStepperProvider';
import type { DuplicateAdTab } from '../../DuplicateAdsTabs/DuplicateAdsTabs';
import DuplicateAdsTabs from '../../DuplicateAdsTabs/DuplicateAdsTabs';
import DuplicatedAdDetails from '../../DuplicatedAdDetails';
import MultipleDuplicateAdsContentWrapper from '../../MultipleDuplicateAdsContentWrapper/MultipleDuplicateAdsContentWrapper';
import { DUPLICATE_ADS_TITLE } from '../constants';
import MultipleDuplicateAdsStepperHeader from '../MultipleDuplicateAdsStepperHeader/MultipleDuplicateAdsStepperHeader';
import { DISABLED_NEXT_TOOLTIP_TEXT, DUPLICATE_LINE_ITEM_HEADER, ERROR_TOOLTIP_TEXT } from './constants';
import SelectLineItemsSection from './SelectLineItemsSection/SelectLineItemsSection';

const [, tabElement] = bem('duplicate-ads-tabs');

const [block, element] = bem('select-line-items-step');

const SelectLineItemsStep = (): React.JSX.Element => {
  const { ads, getSelectedLineItems } = useDuplicateAdsStepperContext();

  const tabs = useMemo(
    () =>
      ads.map(
        (ad): DuplicateAdTab => {
          const isFailed = !getSelectedLineItems(ad.id).length;

          return {
            id: ad.id,
            name: ad.name,
            showCheck: isFailed,
            isFailed: isFailed,
            errorTooltipText: ERROR_TOOLTIP_TEXT,
            component: (
              <div className={tabElement('content-wrapper')}>
                <DuplicatedAdDetails
                  campaignName={ad.lineItem?.campaign.name}
                  lineItemName={ad.lineItem?.name}
                  adId={ad.id}
                  adType={ad.type.displayName}
                  adName={ad.name}
                />
                <p className={element('confirm-line-items-text')}>{DUPLICATE_LINE_ITEM_HEADER}</p>
                <SelectLineItemsSection adId={ad.id} />
              </div>
            ),
          };
        }
      ),
    [ads, getSelectedLineItems]
  );

  const isDisabledNext = useMemo(() => {
    return tabs.some(({ isFailed }) => isFailed);
  }, [tabs]);

  return (
    <div className={block()}>
      <MultipleDuplicateAdsStepperHeader
        tooltipText={DISABLED_NEXT_TOOLTIP_TEXT}
        confirmButtonDisabled={isDisabledNext}
        title={DUPLICATE_ADS_TITLE}
      />
      <MultipleDuplicateAdsContentWrapper>
        <DuplicateAdsTabs tabs={tabs} />
      </MultipleDuplicateAdsContentWrapper>
    </div>
  );
};

export default SelectLineItemsStep;
